/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringListResult } from '../../models/string-list-result';

export interface ApiRateRealgmGet$JsonOdataMetadataMinimal$Params {
  PageSize?: number;
  PlayerName?: string;
}

export function apiRateRealgmGet$JsonOdataMetadataMinimal(http: HttpClient, rootUrl: string, params?: ApiRateRealgmGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
  const rb = new RequestBuilder(rootUrl, apiRateRealgmGet$JsonOdataMetadataMinimal.PATH, 'get');
  if (params) {
    rb.query('PageSize', params.PageSize, {});
    rb.query('PlayerName', params.PlayerName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringListResult>;
    })
  );
}

apiRateRealgmGet$JsonOdataMetadataMinimal.PATH = '/api/rate/realgm';
